import { Center } from "@chakra-ui/layout";
import { Spinner, SpinnerProps } from "@chakra-ui/spinner";
import React from "react";

export const LoadingIndicator = (props: SpinnerProps) => (
  <Center padding="10">
    <Spinner color="white" {...props} />
  </Center>
);
